<template>
	<search-list :pageSizes="[1000]" ref="sl" :where="where" api-path="/converTimeLog/list" :searchKeys="searchKeys" notSearchAll :handleResponse="handleResponse" :autoRefresh="false">
		<mm-lc title="Adv">
			<mm-adv-select no_paused v-model="where.adv_id" multiple />
		</mm-lc>
        <mm-lc title="Show 15 days ago">
            <el-switch v-model="where.show_15" />
        </mm-lc>
		<mm-table slot="dataTable" slot-scope="res" :res="res">
			<el-table-column label="Adv Name" prop="adv_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Offer Id" prop="offer_id" key="offer_id">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id"/>
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name"/>
            <el-table-column v-for="day in days" :key="day" :label="getDate(day)" :prop="`${day}_day_ago`"/>
		</mm-table>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
		};
		const days = [];
		for (let i = 0; i <= 7; i++) {
			days.push(i);
		}
		return {
			where: {
				show_15: false,
			},
			days,
			searchKeys,
            
		};
	},
	methods: {
		timeFormat(date) {
			if (!date || date.length === 0) {
				return '';
			}
			let result = [];
			date.sort();
			for (let d of date) {
				d = new Date((d + 8 * 3600) * 1000);
				let hour = d.getUTCHours();
				hour = hour < 10 ? '0' + hour : hour;
				result.push(hour);
			}
			return result.join(',');
		},
		getDate(day) {
			const date = new Date(new Date().setUTCHours(0) - day * 24 * 3600000);
			const m = date.getUTCMonth() + 1;
			const d = date.getUTCDate();
			return m + '-' + d;
		},
		handleResponse(res) {
			let per = 7;
			if (this.where.show_15) {
				per = 15;
			}
			const days = [];
			for (let i = 0; i <= per; i++) {
				days.push(i);
			}
			this.days = days;
			for (const row of res.rows) {
				for (const k in row) {
					if (/day_ago/.test(k)) {
						row[k] = this.timeFormat(row[k]);
					}
				}
			}
		}
	}
};
</script>

<style scoped>
.edit-camp {
	width: 400px;
	height: 500px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

}
</style>


